import { createFileRoute } from '@tanstack/react-router';
import { useFavoriteListStore } from '@features/favoritelist/favoriteListStore.ts';
import UserLayout from '@components/layout/UserLayout.tsx';
import FavoriteProducts from '@features/favoritelist/FavoriteProducts.tsx';
import { z } from 'zod';
import { useDebouncedCallback } from 'use-debounce';
import { useFavouritesStore } from '@features/favouries/useFavouritesStore.ts';

const searchSchema = z.object({
  q: z.string().optional().default(''),
});

export const Route = createFileRoute('/c/$orgId/$portalId/favourites')({
  validateSearch: v => searchSchema.parse(v),
  component: RouteComponent,
  beforeLoad: ctx => {
    // Odkaz v hlavičce má preload='intent' — beforeLoad se volá i při najetí myší,
    // načítáme až při skutečné navigaci.
    if (ctx.preload) return;
    useFavoriteListStore.getState().loadFavoriteList(ctx.search.q);
    useFavouritesStore.getState().loadFavourites();
  },
});

function RouteComponent() {
  const nav = Route.useNavigate();

  const handleSearch = useDebouncedCallback((query: string) => {
    nav({
      search: p => ({ ...p, q: query }),
    });
  }, 300);
  return (
    <>
      <UserLayout>
        <FavoriteProducts handleSearch={handleSearch} />
      </UserLayout>
    </>
  );
}
